import * as types from '../mutation-types'

// initial state
const state = {
  auths: [],
  routes: []
}

// getters
const getters = {
  auths: state => state.auths,
  routes: state => state.routes
}

// actions
const actions = {
  refreshAuth ({ commit }, payload) {
    commit(types.REFRESH_AUTH, payload)
  }
}

// mutations
const mutations = {
  [types.REFRESH_AUTH] (state, payload) {
    state.routes = payload.routes
    state.auths = payload.auths
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
